import React, {useMemo} from 'react';
import {Pane, Text, TextInput} from "evergreen-ui";
import gql from "graphql-tag";
import {useQuery} from "@apollo/client";
import {useBodyColor} from "../hooks";
import moment from "moment";
import {FixedSizeList as List} from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
import {filter} from 'fuzzaldrin-plus';
import {Spinner} from "@blueprintjs/core";

const GAMES_QUERY = gql`
    query {
        approvedGames(seasonId: 4) {
            id
            isCancelled
            
            schedulingDetails {
                homeTeam {
                    id
                    name(format: WITH_DIVISION_AND_MODIFIER)
                }
                awayTeam {
                    id
                    name(format: WITH_DIVISION_AND_MODIFIER)
                }
                field {
                    id
                    name
                }
                dateTime
            }

            primaryUmpire {
                id
                firstName
                lastName
            }
            
            secondaryUmpire {
                id
                firstName
                lastName
            }
        }
    }
`

const LoadingScreen = () => (
  <div className="wrapper">
    <div className="block mover"></div>
    {/*
    <div className="block jumper"></div>
    <div className="block jumper"></div>
    <div className="block jumper"></div>
    <div className="block jumper"></div>
    <div className="block jumper"></div>
    */}
  </div>
)

export const SearchableSchedule = () => {

    useBodyColor('#fff')

    const { loading, data, error } = useQuery(GAMES_QUERY)

    return (
      <>
        {loading && <Spinner />}

        {data && <GamesTable games={data.approvedGames} />}
      </>
    )
}

const GamesTable = ({ games }) => {

    const [searchText, setSearchText] = React.useState('');

    const filteredGames = useMemo(() => {
      const s = games
        .filter(a => a.schedulingDetails && a.schedulingDetails.homeTeam.id !== 2455 && a.schedulingDetails.homeTeam.id !== 1148)
        .map(game => {
          return {
            ...game,
            tag: `
            ${game.schedulingDetails.homeTeam.name}
            ${game.schedulingDetails.awayTeam.name}
            ${game.schedulingDetails.field.name}
            ${game.primaryUmpire ? `${game.primaryUmpire.firstName} ${game.primaryUmpire.lastName}` : ''}
            ${game.secondaryUmpire ? `${game.secondaryUmpire.firstName} ${game.secondaryUmpire.lastName}` : ''}
          `
          }
        })

      if (searchText) {
        return filter(s, searchText, { key: 'tag' })
      }

      return s
    }, [searchText])

    const sortedGames = useMemo(() => {
      filteredGames.sort((a, b) => moment(a.schedulingDetails.dateTime).isBefore(b.schedulingDetails.dateTime) ? -1 : 1)

      const now = moment()
      const idx = filteredGames.findIndex(game => moment(game.schedulingDetails.dateTime).isSame(now, 'date'))

      return [...filteredGames.slice(idx), ...filteredGames.slice(0, idx)]
    }, [searchText])

    const GamesTableRow = ({ index, style }) => {

        const { primaryUmpire, secondaryUmpire, isCancelled } = sortedGames[index]
        const { homeTeam, awayTeam, dateTime, field } = sortedGames[index].schedulingDetails

        const newStyles = {
            ...style,
            display: 'flex',
            borderBottom: '1px solid lightgrey',
            textDecoration: isCancelled ? 'line-through' : undefined,
            opacity: isCancelled ? 0.5 : undefined
        }

        return (
          <div style={newStyles}>
              <Text flex={1}>{homeTeam.name}</Text>
              <Text flex={1}>{awayTeam.name}</Text>
              <Text flex={1}>{moment(dateTime).format('L')}</Text>
              <Text flex={1}>{moment(dateTime).format('LT')}</Text>
              <Text flex={1}>{field.name}</Text>
              <Text flex={1}>{primaryUmpire ? `${primaryUmpire.firstName} ${primaryUmpire.lastName}` : ''}</Text>
              <Text flex={1}>{secondaryUmpire ? `${secondaryUmpire.firstName} ${secondaryUmpire.lastName}` : ''}</Text>
          </div>
        )
    }

    return (
      <Pane height={'calc(100vh - 74px)'} padding={4}>

          <TextInput
            placeholder={'Search'}
            value={searchText}
            onChange={e => {
              console.warn(e.target.value)
              setSearchText(e.target.value)
            }}
          />

          <AutoSizer>
            {({ height, width }) => (
              <>
                  <div style={{ display: 'flex', borderBottom: '1px solid grey', width: width, padding: 4, backgroundColor: '#efefef'}}>
                      <Text flex={1}>Home Team</Text>
                      <Text flex={1}>Away Team</Text>
                      <Text flex={1}>Date</Text>
                      <Text flex={1}>Time</Text>
                      <Text flex={1}>Field</Text>
                      <Text flex={1}>Primary Umpire</Text>
                      <Text flex={1}>Secondary Umpire</Text>
                  </div>

                  <List
                    height={height}
                    itemCount={sortedGames.length}
                    itemSize={40}
                    width={width}
                  >
                    {GamesTableRow}
                  </List>
              </>
            )}
          </AutoSizer>
      </Pane>
    )
}
